import { render, staticRenderFns } from "./login-after-head-search.vue?vue&type=template&id=6b9966bd&scoped=true&"
import script from "./login-after-head-search.vue?vue&type=script&lang=js&"
export * from "./login-after-head-search.vue?vue&type=script&lang=js&"
import style0 from "./login-after-head-search.vue?vue&type=style&index=0&id=6b9966bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9966bd",
  null
  
)

export default component.exports